export default "__VITE_ASSET__CJ0vXwug__"